export default __webpack_public_path__ + "static/media/monroeKlein.04306c5e.jpg";